import confetti from 'canvas-confetti'

import type { Mission } from '../types/mission'
import { useMissionsStore } from '../stores/useMissionsStore'

import { useUserProgress } from '@/shared/contexts/UserProgress'
import { useMissionsAnalytics } from '@/shared/lib/analytics'
import { api } from '@/shared/services/api'

// Extracted from MissionModal so the claim-reward mutation has one source
// of truth — the missions-screen claim banner (MissionClaimBanner) needs
// the exact same POST + refetch + analytics behavior, triggered from a
// row button instead of the modal's footer button.
export function useMissionClaimReward() {
  const { refetchProgress } = useUserProgress()
  const { refetchMissionProgresses } = useMissionsStore()
  const { trackMissionRewardClaimed } = useMissionsAnalytics()

  const claimReward = async (mission: Mission, originElement?: HTMLElement | null) => {
    if (mission._progress?.claimed) return

    try {
      await api.post(`/user/missions/${mission.uid}/finish`)
      refetchProgress()
      refetchMissionProgresses()
      trackMissionRewardClaimed(mission)
    } catch (error) {
      console.error(error)
    }

    if (originElement) {
      const rect = originElement.getBoundingClientRect()
      const x = (rect.left + rect.width / 2) / window.innerWidth
      const y = (rect.top + rect.height / 2) / window.innerHeight

      confetti({
        origin: { x, y },
        particleCount: 80,
        spread: 80,
        startVelocity: 30
      })
    }
  }

  return { claimReward }
}
